// ЭС6: the journal of a scope record (an event) — who did what to which record of the event, newest first; a row opens the record.
// The same list look as «История»; the server filters by the rights of each section.

import { avatarUrl } from '@confdeck/core-shared';
import { useEffect, useState } from 'react';
import type { Id } from '@confdeck/core-shared';
import { ago } from '../fields/format.ts';
import { useMeta } from '../sync/react.tsx';
import { Avatar, Button } from '../ui/primitives.tsx';
import s from './record.module.css';

interface Item { syncId: number; recordId: Id; typeName: string; title: string; op: string; command: string; actorId: string | null; source: string; at: string; fields: string[]; archived?: 'archived' | 'restored'; reason?: string }

const what = (e: Item) => e.archived === 'archived' ? 'перенёс(ла) в архив' : e.archived === 'restored' ? 'вернул(а) из архива'
  : e.op === 'put' ? (e.command === 'record.import' ? 'импортировал(а)' : 'создал(а)') : 'изменил(а)';

export function ScopeActivity({ recordId, onOpen }: { recordId: Id; onOpen: (id: Id) => void }) {
  const meta = useMeta();
  const [items, setItems] = useState<Item[]>([]);
  const [next, setNext] = useState<number | null>(null);
  const [state, setState] = useState<'loading' | 'ready' | 'error'>('loading');
  const load = async (before: number | null) => {
    try {
      const r = await fetch(`/api/records/${recordId}/activity${before ? `?before=${before}` : ''}`);
      if (!r.ok) throw new Error();
      const j = await r.json() as { items: Item[]; next: number | null };
      setItems((x) => (before ? [...x, ...j.items] : j.items));
      setNext(j.next);
      setState('ready');
    } catch { setState('error'); }
  };
  useEffect(() => { setState('loading'); void load(null); }, [recordId]);

  if (state === 'error') return <div className={s.empty}>Не удалось загрузить журнал</div>;
  if (state === 'loading') return <div className={s.empty}>&nbsp;</div>;
  if (!items.length) return <div className={s.empty}>В событии пока ничего не происходило</div>;
  return (
    <>
      <ol className={s.history}>
        {items.map((e) => {
          const u = meta.user(e.actorId);
          return (
            <li key={e.syncId} className={s.hItem}>
              {u ? <Avatar name={u.name} color={u.color} src={avatarUrl(u)} size={20} /> : <span className={s.hDot} />}
              <div className={s.hBody}>
                <div><b>{u?.name ?? (e.source === 'automation' ? 'Автоматизация' : e.source === 'site' ? 'Сайт' : 'Система')}</b> {what(e)} {e.typeName.toLowerCase()}{' '}
                  <a className={s.hLink} href={`/r/${e.recordId}`} onClick={(ev) => { ev.preventDefault(); onOpen(e.recordId); }}>«{e.title || 'без названия'}»</a> <span className={s.hTime}>{ago(e.at)}</span></div>
                {e.fields.length > 0 && <div className={s.hLine}>{e.fields.join(', ')}</div>}
                {e.reason && <div className={s.hLine}>Причина: {e.reason}</div>}
              </div>
            </li>
          );
        })}
      </ol>
      {next && <div className={s.hMore}><Button size="sm" onClick={() => void load(next)}>Показать раньше</Button></div>}
    </>
  );
}
